import React from 'react'
import { Helmet } from 'react-helmet'
import EshopCategory from './EshopCategory'

const EshopGrand = ({ products = [], eshopInfo = null }) => (
    <>
        <Helmet>
            <title>Grand format | Marguerite Soulier</title>
            <link rel="canonical" href="https://margueritesoulier.fr/grand-format" />
            <meta property="og:url" content="https://margueritesoulier.fr/grand-format" />
        </Helmet>
        <EshopCategory products={products} category="grand" eshopInfo={eshopInfo} />
    </>
)

export default EshopGrand